import styled from "styled-components"

import { DEFERRED, COMPLETED } from "const"
import { TaskStatusType } from "client/utils"
import { Container } from "client/components"

export const TaskListWrapper = styled(Container)`
    margin-bottom: 15px;
    background: ${(props) => props.theme.pageContentBackground};
`
export const TitleWrapper = styled.div<{
    status: TaskStatusType
}>`
    display: flex;

    ${(props) => props.status === DEFERRED && `
        color: grey;
        
        & * {
           color: grey; 
        }
    `}

    ${(props) => props.status === COMPLETED && `
        color: grey;
        text-decoration: line-through;
        
        & * {
           color: grey; 
        }
    `}

    & > div {
        margin-left: 5px;
    }
`

const StatusWrapper = styled.div`
    width: fit-content;
    font-family: ${(props) => props.theme.openSans};
    font-size: 12px;
    font-weight: 600;
    padding: 0 10px;
    border-radius: 10px;
`
export const PendingReviewWrapper = styled(StatusWrapper)`
    background: ${(props) => props.theme.pendingReviewBackground};
    color: ${(props) => props.theme.pendingReviewColor};
`
export const DeferredWrapper = styled(StatusWrapper)`
    border: 1px solid ${(props) => props.theme.deferredBorderColor};
    background: none;
    color: ${(props) => props.theme.deferredColor};
`
